<template>
  <GridItem size="100%" :colidx="1" class="p-5" glassy>
    <GridBody class="m-0 stretch">
      <div class="is-size-3 is-subtle has-text-weight-bold">
        {{ $t("manageAccount.deleteaccForm.title") }}
      </div>
      <div class="space-between">
        <div class="is-size-6 has-text-weight-bold mb-2">
          {{ $t("manageAccount.deleteaccForm.confirmDescription") }}
        </div>
        <button
          class="is-uppercase is-size-6 primary-btn is-danger"
          @click.prevent="$emit('openModal')"
        >
          <span class="m-0 p-0">
            {{ $t("manageAccount.deleteaccForm.submit") }}</span
          >
        </button>
      </div>
    </GridBody>
  </GridItem>
</template>
<style lang="scss" scoped>
.stretch {
  height: 100%;
  align-items: stretch !important;
}
.space-between {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
</style>
<script>
import GridBody from "~/components/GridBody";
import GridItem from "~/components/GridItem";

export default {
  data() {
    return {
      isLoadingData: false,
    };
  },
  components: {
    GridItem,
    GridBody,
  },
  props: {
    openModal: {
      type: Boolean,
      default: false,
    },
  },

  methods: {},
};
</script>
